var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#181800",
    strokeWidth: 1.5,
    d: "M17.5 3a.5.5 0 0 1 .5.5v16.346a.5.5 0 0 1-.842.365l-4.816-4.515a.5.5 0 0 0-.684 0L6.842 20.21A.5.5 0 0 1 6 19.846V3.5a.5.5 0 0 1 .5-.5z"
  })));
};
export { SvgBookmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIHN0cm9rZT0iIzE4MTgwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik0xNy41IDNhLjUuNSAwIDAgMSAuNS41djE2LjM0NmEuNS41IDAgMCAxLS44NDIuMzY1bC00LjgxNi00LjUxNWEuNS41IDAgMCAwLS42ODQgMEw2Ljg0MiAyMC4yMUEuNS41IDAgMCAxIDYgMTkuODQ2VjMuNWEuNS41IDAgMCAxIC41LS41aDExWiIvPjwvc3ZnPg==";